export default __webpack_public_path__ + "static/media/munnar1.0765efd2.jpg";